import React from "react";
import { useSelector } from "react-redux";
import CartItem from "./CartItem";
import { getCart } from "./../redux/products/productsReducer";

const CartBody = () => {
  const selectedProducts = useSelector(getCart);

  return (
    <div className="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4">
      {selectedProducts.map((selectedProduct) => (
        <CartItem
          key={selectedProduct?.productId}
          selectedProduct={selectedProduct}
        />
      ))}
    </div>
  );
};

export default CartBody;
